import { Component, OnInit } from "@angular/core";
import { ErrorInfo, ErrorInfoResolver } from "@scisys-uim/uim-common";
import { FirearmAssignmentService } from "assets-service";

const TOKEN_PARAM_KEY = 'assignmentAcknowledgementToken';

@Component({
    selector: 'app-ranger-acknowledge-assignment',
    templateUrl: './acknowledge-assignment.component.html',
    styleUrls: ['./acknowledge-assignment.component.scss']
})
export class RangerAcknowledgeAssignmentComponent implements OnInit {

    acknowledged: boolean;
    error: ErrorInfo;
    jwt: string;

    constructor(
        protected firearmAssignmentService: FirearmAssignmentService,
        protected errorInfoResolver: ErrorInfoResolver
    ) { }


    ngOnInit(): void {
        const searchParams = new URLSearchParams(window.location.search);
        this.jwt = searchParams.get(TOKEN_PARAM_KEY);
    }

    isAcknowledgeAssignmentEnabled() {
        return this.jwt != null && this.acknowledged == null && this.error == null;
    }

    acknowledgeAssignmentHandover() {
        this.firearmAssignmentService.acknowledgeAssignment({ jwt: this.jwt }).subscribe(noResult => {
            this.acknowledged = true;
        }, error => {
            this.error = this.errorInfoResolver.toErrorInfo(error);
            throw error;
        }
        );
    }
}